export interface IWindowKeyboardShortcutController {
  handleKeyboardEvent: (e: KeyboardEvent) => void;
}

export enum KeyboardKey {
  H = 'H'
}
